/* loaded by smart-asset */
export default require("./pause~xDleoKju.png")